<template>
  <div class="eng-header">
    <div class="backarrowDiv" v-on:click="prevChapter">
      <inline-svg
        class="arrow-svg-game"
        :src="arrowIconPath.arrowIconPrevious"
      ></inline-svg>
    </div>
    <h4 class="eng-header-title">{{ lessonName || "הרכבת משפטים" }}</h4>
    <div>
      <inline-svg
        class="lives"
        :src="require(`../../assets/svg/${3 - lost}lives.svg`).default"
      ></inline-svg>
    </div>
  </div>
</template>

<script>
import { getArrowIconPath } from "../../utils/svgConfig";
import { languageDirectionMapping } from "../../main";

export default {
  name: "eng-header",
  props: ["lost", "data", "externalData"],
  data() {
    return {
      lessonName: this.$t("engGame.eng-header.lessonName"),
      arrowIconPath: {
        arrowIconNext: "",
        arrowIconPrevious: ""
      }
    };
  },
  async created() {
    this.arrowIconPath = getArrowIconPath(localStorage.getItem("srcDirection"));
  },
  computed: {},
  mounted() {
    this.lessonName = this.$t("engGame.eng-header.lessonName");
    if (this.externalData) this.lessonName = this.externalData.name;
    if (this.data) this.lessonName = this.data.name;
    // this.lessonName =
    //   this.externalData.name || this.data.name || "משחק המשפטים";
  },
  watch: {
    externalData() {
      this.lessonName = this.$t("engGame.eng-header.lessonName");
      if (this.externalData) this.lessonName = this.externalData.name;
      if (this.data) this.lessonName = this.data.name;
      //   this.lessonName =
      //     this.externalData.name || this.data.name || "משחק המשפטים";
    }
  },

  methods: {
    prevChapter: function(event) {
      if (Object.keys(this.externalData).length) {
        this.$router.push({
          path: `/external-sentence/`
        });
      } else {
        this.$router.push({
          path: `/chapter/`
        });
      }
    }
  },
  components: {}
};
</script>

<style scoped>
.eng-header {
  display: grid;
  justify-content: space-between;
  background-color: var(--header-primary);
  height: 60px;
  grid-template-columns: 15% 1fr 15%;
  align-items: center;
  justify-items: center;
}
@media (min-width: 780px) {
  .eng-header {
    width: 100%;
  }
}
.lives {
  width: 38px;
  aspect-ratio: 1;
  transform: translateY(4px);
}
.eng-header-title {
  margin: 0px !important;
  font: var(--medium-font);
  text-align: center;
  color: var(--button-primary-text);
}
.backarrowDiv {
  display: flex;
  width: 50px;
  height: 50px;
}
.arrow-svg-game {
  margin: auto;
  height: 30px;
  fill: var(--bg-primary);
  aspect-ratio: 1/1;
}
</style>



// WEBPACK FOOTER //
// eng-header.vue?52683dac